import React, { useState, useEffect } from "react";
import {
    AppBar,
    Box,
    Toolbar,
    //Button,
    Menu,
    MenuItem,
    List, ListItem, ListItemButton, ListItemIcon,ListItemText, 
} from "@mui/material";
//import OrdersIcon from "@mui/icons-material/ShoppingCart";
//import InvoiceIcon from "@mui/icons-material/Receipt";
import TranslateIcon from "@mui/icons-material/Translate";
//import { API_BASE_URL } from "../config.ts";
//import { useTranslation } from "react-i18next";
//import axiosExt from '../axios.tsx';
import i18n from "../i18n.ts";
import logo from '../assets/DACustomsBlueGreenSmall.png';

interface LayoutProps {
    children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
    //const { t } = useTranslation();

    //const navigate = useNavigate();
    //const roles: string[] = JSON.parse(localStorage.getItem("roles") || "[]");
    //const isAdmin = roles.includes("admin");

    const [languageMenuAnchor, setLanguageMenuAnchor] = useState<null | HTMLElement>(null);
    const [selectedLanguage, setSelectedLanguage] = useState<string>(localStorage.getItem("language") || "en");

    //const handleLogout = () => {
    //    localStorage.removeItem("token");
    //    localStorage.removeItem("roles");
    //    navigate("/");
    //};

    //const [menuAnchor, setMenuAnchor] = useState<null | { anchor: HTMLElement, menu: string }>(null);

    //const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, menuName: string) => {
    //    setMenuAnchor({ anchor: event.currentTarget, menu: menuName });
    //};

    //const handleMenuClose = () => {
    //    setMenuAnchor(null);
    //};

    useEffect(() => {
        const userLang = localStorage.getItem("language") || "en";
        if (localStorage.getItem("token")) {
                setSelectedLanguage(userLang);
                i18n.changeLanguage(userLang);
        };

    }, []);

    const handleLanguageChange = async (lang: string) => {
        setSelectedLanguage(lang);
        i18n.changeLanguage(lang);
        localStorage.setItem("language", lang);
        
        //if (localStorage.getItem("token")) {
        //    try {
        //        await axiosExt.post(
        //            `${API_BASE_URL}/users/set-language/${localStorage.getItem("userId")}`,
        //            { language: lang },
        //            {
        //                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        //            }
        //        );
        //    } catch (error) {
        //        console.error("Error updating language in API", error);
        //    }
        //}

        setLanguageMenuAnchor(null);
    };

    return (
        <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", width:"100vw" }}>

            {/* Top Navigation Bar */}
            <AppBar position="fixed">
                <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', backgroundColor: "#0F0F10" }}>
                    {/* App Title */}
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <img
                            src={logo}
                            alt="DA Customs"
                            style={{ height: 40, marginRight: 16, flexGrow: 1, objectFit: "contain" }}
                        />
                    </Box>

                    {/* Main Menu Items */}
                    {/*<Button color="inherit" startIcon={<OrdersIcon />} onClick={(e) => handleMenuOpen(e, "orders")}>*/}
                    {/*    {t("Orders")}*/}
                    {/*</Button>*/}

                    <Box sx={{ display: 'flex', gap: 1 }}>
                        {/*<Button color="inherit" onClick={() => navigate("/orderdetailspage?view=grid")} startIcon={<OrdersIcon />}>*/}
                        {/*    {t("Orders")}*/}
                        {/*</Button>*/}

                        {/*<Button color="inherit" onClick={() => navigate("/invoices")} startIcon={<InvoiceIcon />}>*/}
                        {/*    {t("Invoices")}*/}
                        {/*</Button>*/}

                        <List>
                            <ListItem disablePadding>
                                <ListItemButton onClick={(e) => setLanguageMenuAnchor(e.currentTarget)}>
                                    <ListItemIcon sx={{ color: 'inherit', minWidth: 'unset', mr: 1 }}><TranslateIcon sx={{ color: 'inherit' }} /></ListItemIcon>
                                    <ListItemText primary={`${selectedLanguage.toUpperCase()}`} />
                                </ListItemButton>
                            </ListItem>
                        </List>

                        {/* Language Menu */}
                        <Menu
                            anchorEl={languageMenuAnchor}
                            open={Boolean(languageMenuAnchor)}
                            onClose={() => setLanguageMenuAnchor(null)}
                        >
                            <MenuItem onClick={() => handleLanguageChange("en")}>English (EN)</MenuItem>
                            <MenuItem onClick={() => handleLanguageChange("de")}>Deutsch (DE)</MenuItem>
                        </Menu>

                    </Box>
                </Toolbar>
            </AppBar>

            {/* Main Content */}
            <Box component="main" sx={{ mt: 8, p: 1 }}>
                {children}
            </Box>
        </Box>
    );
};

export default Layout;
